import React from 'react';
import IconWrap from '../../IconWrap';
const Premium = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: "#7579FF"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M11.472 18v-1.243a5.754 5.754 0 01-1.804-.423c-.531-.227-.946-.548-1.244-.965-.298-.416-.439-.934-.423-1.552l.017-.031h2.308c0 .563.168.967.504 1.21.336.245.759.367 1.268.367.493 0 .87-.101 1.13-.303a.993.993 0 00.398-.827c0-.34-.127-.618-.382-.832-.249-.215-.68-.415-1.292-.6-.802-.227-1.466-.467-1.992-.719-.52-.257-.91-.557-1.17-.902-.255-.35-.382-.778-.382-1.287 0-.707.29-1.285.87-1.735.585-.455 1.37-.722 2.357-.802V6h1.292v1.375c.949.11 1.694.419 2.236.928.547.505.815 1.163.804 1.975l-.024.031h-2.309c0-.496-.132-.879-.398-1.148-.265-.27-.623-.404-1.073-.404-.466 0-.815.105-1.048.316-.228.206-.342.481-.342.826 0 .328.12.595.358.801.244.202.688.402 1.333.6.797.244 1.455.496 1.975.757.526.256.916.557 1.17.902.26.345.391.766.391 1.262 0 .727-.293 1.312-.878 1.754-.58.437-1.365.696-2.357.776V18h-1.293z",
        fill: "#fff"
    })));
Premium.displayName = 'Premium';
export default Premium;
